import { NavPage } from '@/components/breadcrumbs/Breadcrumbs';
import CatalogueExplorer from '@/components/catalogue/explorer/CatalogueExplorer';
import { Button } from '@/components/form/Button';
import { ButtonVariant } from '@/components/form/buttonHelper';
import SiChevronLeft from '@/icons/SiChevronLeft';
import { useCurrentPurchaseOrderLink } from '@/lib/getMyLinks';
import { useCatalogueRoutePrefix } from '@/services/catalogue/useCatalogueRoutePrefix';
import { usePoName, usePoSelectedProductList } from '@/services/purchaseOrders/usePurchaseOrderService';
import { usePONavigateAndValidate } from '@/services/purchaseOrders/validation/purchaseOrderHooks';
import { FC } from 'react';
import { useParams } from 'react-router';
import SavePurchaseOrderButton from './SavePurchaseOrder';

export const PurchaseOrderSelectedProducts: FC = () => {
  const { orderId } = useParams();

  const navigateAndValidate = usePONavigateAndValidate();

  const poLink = useCurrentPurchaseOrderLink();

  const poName = usePoName();
  const nameToDisplay = poName || 'Create';

  const breadcrumbs: NavPage[] = [
    {
      name: 'Orders / Quotes',
      to: poLink
    },
    {
      name: nameToDisplay,
      to: `${poLink}/${orderId}/poCatalogue`
    },
    {
      name: 'My Order',
      to: `${poLink}/${orderId}/poCatalogue/selectedProducts`
    }
  ];

  const routePrefix = useCatalogueRoutePrefix();

  const selectedProductIds = usePoSelectedProductList().map(p => p.productId);

  return (
    <>
      <CatalogueExplorer
        productIds={selectedProductIds}
        showCategories={false}
        header={{
          step: 1,
          title: nameToDisplay,
          subtitle: `My Order`,
          breadcrumbs,
          controls: (
            <>
              {/*<HelpButton />*/}
              <Button onClick={() => navigateAndValidate(`${routePrefix}/poCatalogue`)} variant={ButtonVariant.Mono}>
                <SiChevronLeft className="text-xl" />
                <span>Back to full catalogue</span>
              </Button>
              <Button
                variant={ButtonVariant.Secondary}
                onClick={() => {
                  navigateAndValidate(`${routePrefix}/poCatalogue/selectedProducts`);
                }}
              >
                My Order
              </Button>
              <SavePurchaseOrderButton />
              <Button
                variant={ButtonVariant.Primary}
                onClick={() => navigateAndValidate(`${routePrefix}/poCatalogue/deliveryDetails`)}
              >
                Delivery Details
              </Button>
            </>
          )
        }}
        navigate={navigateAndValidate}
      />
    </>
  );
};
